
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabserviceinjalgaon() {



const cardData = {
  keyword: 'Corporate Cab Services in Jalgaon MIDC',
  heading: 'eTravo: Premier Corporate Cab Services in Jalgaon MIDC',
  headingDescription: `eTravo is proud to offer dependable and professional corporate cab services in Jalgaon MIDC, designed specifically to meet the diverse transportation needs of businesses, employees, and executives operating in this vibrant industrial zone. We specialize in seamless employee commute solutions, executive travel, and client transportation with a commitment to safety, punctuality, and customer satisfaction. Our fleet comprises modern, GPS-enabled, air-conditioned vehicles maintained to the highest standards, and operated by experienced drivers trained in corporate protocols. By choosing eTravo, companies benefit from flexible rental plans, optimized routing, and real-time support — making daily corporate travel efficient and hassle-free throughout the Jalgaon industrial landscape.`,

  top: 'Key Business and Industrial Locations Covered by eTravo in Jalgaon MIDC',
  topPlaces: [
    {
      title: 'Jalgaon MIDC Industrial Park',
      description: `A major industrial hub hosting textile, chemical, and manufacturing units. eTravo ensures reliable employee cab services to cover shift changes and operational hours efficiently.`
    },
    {
      title: 'Jalgaon City Center',
      description: `The administrative and commercial heart of Jalgaon where corporate offices, banks, and government buildings are located. Our executive cabs provide smooth transport for meetings and official visits.`
    },
    {
      title: 'Jalgaon Railway Station',
      description: `We offer convenient railway station pickup and drop services, linking regional train travel with workplace commutes for employees and business clients alike.`
    },
    {
      title: 'Industrial Warehouses and Logistics Centers',
      description: `Supporting large warehouses and logistics hubs with scheduled and on-demand cab services for warehouse staff and logistics personnel, ensuring operational continuity.`
    },
    {
      title: 'Nearby Business Parks and Tech Zones',
      description: `We extend our corporate shuttle and cab hire services to adjacent tech and business parks, facilitating inter-zone corporate travel and team commutes.`
    }
  ],

 services: [
  {
    name: 'Jalgaon MIDC Corporate Cab Rentals',
    description: `Tailored rental plans crafted for businesses in Jalgaon MIDC, including options for long-term corporate contracts and short-term event transportation needs. Our flexible packages ensure hassle-free booking, timely service, and a fleet maintained to corporate standards to support your business operations seamlessly.`
  },
  {
    name: 'Employee Transport Cab Jalgaon MIDC',
    description: `Dependable employee transport aligned with factory and office shift timings, ensuring safe, punctual, and comfortable commutes daily. We use GPS-enabled vehicles monitored by a dedicated support team to guarantee timely arrivals and smooth drop-offs for your workforce every day.`
  },
  {
    name: 'Business Cab Services Jalgaon MIDC',
    description: `Flexible and prompt cab services designed for business owners and corporate staff traveling for meetings, site visits, and client interactions. Our professional drivers are well-versed with local routes and traffic patterns, providing efficient travel with comfort and reliability.`
  },
  {
    name: 'Corporate Staff Cabs Jalgaon MIDC',
    description: `Group transport solutions with multi-route planning and GPS tracking, perfect for corporate teams commuting together. This service promotes cost savings, reduces traffic congestion, and ensures employee safety through coordinated batch pickups and drop-offs.`
  },
  {
    name: 'Reliable Corporate Cab Service Jalgaon MIDC',
    description: `A commitment to consistent quality, featuring clean, well-maintained vehicles and professional drivers to uphold corporate standards. Our focus is on punctuality, courteous service, and proactive communication to meet the unique needs of corporate clients.`
  },
  {
    name: 'AC Corporate Cabs Jalgaon MIDC',
    description: `Comfort-oriented air-conditioned cabs to provide a pleasant travel experience regardless of Jalgaon’s weather conditions. Ideal for daily commutes as well as executive rides, our AC fleet ensures a cool and relaxing journey even during peak summer months.`
  },
  {
    name: 'Staff Pickup and Drop Cab Jalgaon MIDC',
    description: `Comprehensive staff transportation service supporting multiple shifts including night duties, with flexible scheduling and timely pickups. Our 24/7 availability and experienced drivers make sure your workforce travels safely and punctually, round the clock.`
  },
  {
    name: 'Affordable Business Cab Rentals Jalgaon MIDC',
    description: `Cost-effective cab rental options for small and medium enterprises as well as large corporations, emphasizing transparent pricing and reliability. Our scalable plans allow businesses to adjust vehicle numbers and routes according to evolving operational needs, optimizing transport budgets.`
  },
  {
    name: 'Executive Cab Services Jalgaon MIDC',
    description: `Premium executive transportation services with experienced chauffeurs, ideal for business meetings, airport transfers, and client hospitality. Our luxury vehicle fleet and discreet, courteous drivers ensure a high-end travel experience for VIPs and senior management.`
  },
  {
    name: 'Monthly Corporate Cab Rentals Jalgaon MIDC',
    description: `Fixed-route monthly cab plans designed to simplify employee transportation logistics, reduce administrative efforts, and ensure smooth operations. These plans offer consistent service quality, easy billing, and quick adjustments in coordination with HR and admin teams.`
  },
  {
    name: 'Industrial Area Employee Transport Jalgaon MIDC',
    description: `Optimized employee transport for factories and industrial units, facilitating smooth travel between residential areas and work zones. Our routing and scheduling systems prioritize safety, punctuality, and compliance with industrial regulations.`
  },
  {
    name: 'Corporate Client Cabs Jalgaon MIDC',
    description: `Dedicated client transport services ensuring punctual, comfortable, and professional travel experience for visiting business guests. From airport pickups to site visits, we help make a great impression with polished vehicles and trained drivers.`
  },
  {
    name: 'Business Meeting Cabs Jalgaon MIDC',
    description: `Rapid response cab services tailored for executives attending urgent meetings, ensuring timely arrivals within Jalgaon and nearby locations. We offer easy booking options and prompt dispatch to keep your business running smoothly.`
  },
  {
    name: 'Jalgaon Industrial Area Cab Hire',
    description: `Flexible, on-demand cab hire services across Jalgaon’s industrial corridors for site inspections, logistics support, and corporate errands. Our knowledgeable drivers are familiar with the industrial landscape, providing efficient and hassle-free transport solutions.`
  },
  {
    name: 'Corporate Shuttle Cabs Jalgaon MIDC',
    description: `Group transport services utilizing minibuses or large vans, ideal for bulk employee movement during shift changes or corporate events. This service improves operational efficiency while reducing the environmental footprint through consolidated travel.`
  }
],

  tableData: [
    ['Jalgaon MIDC Corporate Cab Rentals', 'Employee Transport Cab Jalgaon MIDC'],
    ['Business Cab Services Jalgaon MIDC', 'Corporate Staff Cabs Jalgaon MIDC'],
    ['Reliable Corporate Cab Service Jalgaon MIDC', 'AC Corporate Cabs Jalgaon MIDC'],
    ['Staff Pickup and Drop Cab Jalgaon MIDC', 'Affordable Business Cab Rentals Jalgaon MIDC'],
    ['Executive Cab Services Jalgaon MIDC', 'Monthly Corporate Cab Rentals Jalgaon MIDC'],
    ['Industrial Area Employee Transport Jalgaon MIDC', 'Corporate Client Cabs Jalgaon MIDC'],
    ['Business Meeting Cabs Jalgaon MIDC', 'Jalgaon Industrial Area Cab Hire'],
    ['Corporate Shuttle Cabs Jalgaon MIDC', '']
  ],


"whychoose": [
  {
    "WhyChooseheading": "Tailored Corporate Cab Services for Jalgaon MIDC",
    "WhyChoosedescription": "eTravo provides customized cab solutions designed specifically for businesses operating in Jalgaon MIDC, a thriving industrial hub. Our services focus on ensuring timely employee commutes, reducing downtime, and boosting overall operational efficiency. With our reliable transport options, companies can enhance workforce productivity while maintaining comfort and safety standards."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles to Suit Corporate Needs",
    "WhyChoosedescription": "Our extensive fleet includes sedans, SUVs, and multi-utility vehicles, allowing your business to choose the ideal vehicle type for executive travel, group employee transport, or client visits. All vehicles are maintained regularly to guarantee safety, comfort, and reliability."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Local Knowledge",
    "WhyChoosedescription": "Our professional drivers are well-trained and possess detailed knowledge of Jalgaon MIDC’s roads and industrial layout. Their expertise ensures efficient navigation, punctual pickups and drop-offs, and adherence to corporate etiquette for a seamless travel experience."
  },
  {
    "WhyChooseheading": "Flexible Booking Options to Match Shift Patterns",
    "WhyChoosedescription": "Understanding the diverse shift schedules common in industrial sectors, we offer flexible booking solutions including scheduled pickups, on-demand rides, and long-term contracts, enabling businesses to manage employee transportation effortlessly."
  },
  {
    "WhyChooseheading": "Real-Time GPS Tracking for Safety and Transparency",
    "WhyChoosedescription": "All our vehicles are equipped with GPS tracking systems, providing real-time monitoring for corporate clients. This enhances ride safety, accountability, and allows prompt responses to any travel concerns."
  },
  {
    "WhyChooseheading": "Transparent Billing with Detailed Invoices",
    "WhyChoosedescription": "We provide clear and comprehensive billing statements, including trip details and fare breakdowns, facilitating easy financial management and reimbursement for corporate accounts."
  },
  {
    "WhyChooseheading": "Strict Safety and Hygiene Standards",
    "WhyChoosedescription": "Our fleet undergoes regular sanitization and maintenance, with drivers following strict hygiene protocols to ensure a safe and healthy travel environment for all passengers."
  },
  {
    "WhyChooseheading": "Dedicated Account Management Support",
    "WhyChoosedescription": "Each corporate client is assigned a dedicated account manager who provides personalized assistance, helps manage bookings, addresses queries promptly, and ensures a smooth transportation experience."
  }
]
}

const faqData = [
  [
    {
      question: "Which areas do your Jalgaon MIDC cab services cover?",
      answer: "Our services cover the entire Jalgaon MIDC area, including surrounding industrial zones, ensuring seamless transportation for your employees."
    },
    {
      question: "Can we schedule regular rides for employees working in shifts?",
      answer: "Yes, we offer scheduling options for recurring rides that cater to fixed and rotating shift patterns."
    },
    {
      question: "Is monthly consolidated billing available for corporate clients?",
      answer: "Absolutely. We provide detailed monthly invoices with comprehensive trip logs to simplify expense tracking."
    },
    {
      question: "Are your drivers trained to maintain corporate professionalism?",
      answer: "Yes, all our drivers undergo training in corporate etiquette, safe driving, and local route navigation."
    },
    {
      question: "How do you ensure the safety of passengers during commutes?",
      answer: "We use GPS tracking, conduct regular vehicle inspections, and enforce strict safety and hygiene protocols."
    },
    {
      question: "Do corporate clients have access to dedicated support?",
      answer: "Yes, corporate clients receive dedicated account management and priority support for quick assistance."
    }
  ]
];

const testimonialsData = [
  {
    name: "Mr. Rahul Deshmukh",
    designation: "Operations Head, Jalgaon Manufacturing Ltd.",
    rating: [1, 1, 1, 1, 1],
    text: "“eTravo’s corporate cab services have helped us maintain punctuality and ensure employee safety consistently.”"
  },
  {
    name: "Ms. Sneha Patil",
    designation: "HR Manager, Jalgaon Agro Industries",
    rating: [1, 1, 1, 1, 1],
    text: "“The flexibility and reliability of eTravo’s services make them our preferred transportation partner in Jalgaon MIDC.”"
  }
];

































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Jalgaon MIDC",
  "image": "https://www.etravo.in/images/keyword/cab-service-jalgaon-midc.jpg",
  "description": "Reliable corporate cab service in Jalgaon MIDC offering employee transport, business travel, industrial area cabs, and affordable AC corporate rentals with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4300"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1699",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-services-jalgaon-midc"
  }
};







    return (
        <div>

<Helmet>
  <title>Corporate Cab Services in Jalgaon MIDC | Corporate & Industrial Cabs | eTravo</title>
  <meta 
    name="description" 
    content="Book reliable corporate cab service in Jalgaon MIDC for staff commute, business meetings, and industrial transport. Affordable AC corporate cabs available at eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/80.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabserviceinjalgaon;